var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.834.333H1.5A1.333 1.333 0 00.167 1.667v10.666A1.333 1.333 0 001.5 13.667h8a1.333 1.333 0 001.334-1.334v-8l-4-4zM6.5 9.667v2h-2v-2H2.834L5.5 7l2.667 2.667H6.5zM6.167 5V1.333L9.834 5H6.167z",
    fill: "#343434"
  })));
}
export default SvgUploadFile;